import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { Box } from '@mui/material'
import { crmApi } from '../../../features/crm/crmApi'
import { ui, tone } from '../../../utils/uiTokens'
import { CURATOR, MODERATOR, SALES_HEAD, SELLER, SUBJECT_HEAD, SUPER_ADMIN } from '../../../utils/constants'

export const CRM_ROLES = [SELLER, MODERATOR, SUBJECT_HEAD, CURATOR, SALES_HEAD, SUPER_ADMIN]

// Привязка Telegram для уведомлений CRM. Бот не настроен (enabled=false) - только приглушённая подпись.
const TelegramLink = ({ userRole }: { userRole: string }) => {
    const { formatMessage } = useIntl()
    const [waiting, setWaiting] = useState(false)
    const { data } = crmApi.useGetTelegramQuery(undefined, {
        skip: !CRM_ROLES.includes(userRole),
        pollingInterval: waiting ? 10000 : 0,
    })
    const [unlink] = crmApi.useUnlinkTelegramMutation()

    if (!data) return null
    if (!data.enabled) return <Box sx={{ ...row, color: ui.muted, cursor: 'default' }}>✈ {formatMessage({ id: 'crmTgDisabled' })}</Box>

    if (data.linked)
        return (
            <Box sx={{ ...row, cursor: 'default', color: tone.ok.text, fontWeight: 600, justifyContent: 'space-between' }}>
                <span>✈ {formatMessage({ id: 'crmTgLinked' })}</span>
                <Box
                    component="button"
                    type="button"
                    onClick={() => unlink()}
                    sx={{ border: 'none', background: 'transparent', color: ui.muted, fontSize: '12px', cursor: 'pointer', font: 'inherit', padding: 0 }}
                >
                    {formatMessage({ id: 'crmTgUnlink' })}
                </Box>
            </Box>
        )

    return (
        <Box
            component="a"
            href={data.deepLink || undefined}
            target="_blank"
            rel="noreferrer"
            onClick={() => setWaiting(true)}
            sx={{ ...row, color: ui.pink, fontWeight: 600, textDecoration: 'none', '&:hover': { background: ui.pinkSoft } }}
        >
            ✈ {formatMessage({ id: 'crmTgLink' })}
        </Box>
    )
}

const row = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '10px',
    margin: '2px 0',
    borderRadius: '12px',
    fontSize: '14px',
    cursor: 'pointer',
}

export default TelegramLink
